import axios from "axios"


class AuthService {
    _url = "http://localhost:"

    login({email, password}) {
        return axios.post('/api/auth/login', {
            email,
            password
        })
    }

    logout() {
        return axios.post('/api/auth/logout')
    }

    getMe() {
        return axios.get('/api/auth/get-me')
    }

    changePassword({oldPassword, newPassword}) {
        return axios.post('/api/auth/change-password', {
            old_password: oldPassword,
            new_password: newPassword
        })
    }

    register({email, name, surname, phone, country, description, password, confirmPassword}) {
        return axios.post('/api/auth/register', {
            email,
            name,
            // surname,
            // phone,
            // country,
            // description,
            password: password,
            confirmPassword: confirmPassword,
        });
    }

    profile({name, surname, phone, country, description}) {
        return axios.post("/api/auth/profile", {
            name, 
            surname, 
            phone, 
            country, 
            description
        })
    }

    profileImage(file) {
        return axios.post("/api/auth/profile-image", file)
    }

    resetPassword({email, new_password}) {
        return axios.post('/api/auth/reset-password', {
            email,
            new_password,
        })
    }

    forgotPassword({email}) {
        return axios.post(`/api/auth/forgot-password`, {
            email
        })
    }


    // admin

    getAdminUsers(params) {
        return axios.get("/admin/users", {
            params: params
        })
    }

    getAdminUsersCount(params) {
        return axios.get("/admin/users/count", {
            params: params
        })
    }

    getAdminUserSession({id}) {
        return axios.get(`/admin/user/session/${id}`)
    }

    removeAdminUserSession({account_id, token}) {
        return axios.post(`/admin/user/session/remove`, {
            account_id,
            token
        })
    }
}


const authService = new AuthService()

export default authService;